import { render, staticRenderFns } from "./dealerKPI.vue?vue&type=template&id=6081f697&scoped=true"
import script from "./dealerKPI.vue?vue&type=script&lang=js"
export * from "./dealerKPI.vue?vue&type=script&lang=js"
import style0 from "./dealerKPI.vue?vue&type=style&index=0&id=6081f697&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081f697",
  null
  
)

export default component.exports